import { GlobalPositionStrategy, OverlayPositionBuilder } from '@angular/cdk/overlay';
import { Injectable } from '@angular/core';
import * as i0 from "@angular/core";
export class SnackbarPositionStrategy extends GlobalPositionStrategy {
    /**
     * Sets the top position of the overlay. Clears any previously set vertical position.
     * @param value New top offset.
     */
    top(value = '') {
        super.top();
        if (value === '0') {
            this['_topOffset'] = '64px';
            this['_height'] = 'auto';
        }
        return this;
    }
}
export class ExtendedPositionBuilder extends OverlayPositionBuilder {
    /**
     * Creates a global position strategy.
     */
    global() {
        return new SnackbarPositionStrategy();
    }
    static { this.ɵfac = /*@__PURE__*/ (() => { let ɵExtendedPositionBuilder_BaseFactory; return function ExtendedPositionBuilder_Factory(__ngFactoryType__) { return (ɵExtendedPositionBuilder_BaseFactory || (ɵExtendedPositionBuilder_BaseFactory = i0.ɵɵgetInheritedFactory(ExtendedPositionBuilder)))(__ngFactoryType__ || ExtendedPositionBuilder); }; })(); }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ExtendedPositionBuilder, factory: ExtendedPositionBuilder.ɵfac }); }
}
//# sourceMappingURL=snackbar-position-strategy.js.map